import React from "react";

export const PenguinIcon: React.FC = () => {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
      <g id="color">
        <path
          fill="#3F3F3F"
          stroke="none"
          d="M45,12c0.964-0.9633,4.0386-2.304,4.3591-2.9468c0.1525-0.3049-0.6522-0.8271-0.964-0.964 c-0.9577-0.4188-3.213,0-4.177-0.1606c-3.5341-1.7668-6.1043-2.0879-8.3527-1.1245c-3.5341,1.6068-4.1764,5.7826-4.1764,7.3894 c0,1.4488-0.0815,4.3556-0.3217,5.7826c-0.0971,0.5769-0.4145,1.7114-0.6422,2.2497c-0.6428,2.249-2.2497,4.4981-3.5348,6.1043 c-0.9248,1.1569-8.6744,9.9602-9.9595,12.5303c-1.1538,2.236-4.1764,7.3894-2.8913,9.3167 c1.3106,0.1879,1.6062-4.1764,8.0447-9.3167C23.9415,39.4529,26.5249,36.8275,27,36c0.2251-0.3921,0.0085,1.548,0,2 c-0.1486,7.8633,1,12,0.9931,16.6751c0.4817,2.5702,0.5028,3.4918,0,4.4981c-1.4463,2.8913-4.0164,2.8913-4.6586,4.0164 c0,0,2.9989,2.09,9.8322-2.0498 M45.3795,38.845c1.1031,1.1148,4.1969,3.2073,4.975,3.9433 c1.942,1.8358,6.5844,8.3527,7.6235,7.3888c0.349-0.3211,0.8874-1.9479,0.6954-2.5708c-0.8143-2.6416-4.3123-7.9998-7.1632-12.9309 c-2.8824-4.9856-4.9433-9.3882-4.9433-9.3882l-3.2527-3.5616 M36.7544,61.4449c5.3265,4.4657,12.0519,0.9147,12.0519,0.9147 c0-0.5748-3.9442-2.6363-8.0167-4.7347"
        />
        <path
          fill="#FFFFFF"
          stroke="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M32,14c0.0291,1.3236,7.2847,6.8282,11,1c0,0-1.0451,11.0186,1,15c2.3884,4.6498-0.4794,22.871-5,29 c-1.5278,2.0714-7.151,5.2303-10-5s-2-9.8618-2-16S34.5308,19,32,14z"
        />
      </g>
      <g id="hair" />
      <g id="skin" />
      <g id="skin-shadow" />
      <g id="line">
        <path
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M32,14c0.0291,1.3236,7.2847,6.8282,11,1c0,0-1.0451,11.0186,1,15c2.3884,4.6498-0.4794,22.871-5,29 c-1.5278,2.0714-7.151,5.2303-10-5s-2-9.8618-2-16S34.5308,19,32,14z"
        />
        <path
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M45,12c0.964-0.9633,4.0386-2.304,4.3591-2.9468c0.1525-0.3049-0.6522-0.8271-0.964-0.964c-0.9577-0.4188-3.213,0-4.177-0.1606 c-3.5341-1.7668-6.1043-2.0879-8.3527-1.1245c-3.5341,1.6068-4.1764,5.7826-4.1764,7.3894c0,1.4488-0.0815,4.3556-0.3217,5.7826 c-0.0971,0.5769-0.4145,1.7114-0.6422,2.2497c-0.6428,2.249-2.2497,4.4981-3.5348,6.1043 c-0.9248,1.1569-8.6744,9.9602-9.9595,12.5303c-1.1538,2.236-4.1764,7.3894-2.8913,9.3167 c1.3106,0.1879,1.6062-4.1764,8.0447-9.3167C23.9415,39.4529,26.5249,36.8275,27,36c0.2251-0.3921,0.0085,1.548,0,2 c-0.1486,7.8633,1,12,0.9931,16.6751c0.4817,2.5702,0.5028,3.4918,0,4.4981c-1.4463,2.8913-4.0164,2.8913-4.6586,4.0164 c0,0,2.9989,2.09,9.8322-2.0498 M47.9654,39.92c1.0227,1.1148,2.2772,2.1323,2.9986,2.8683 c1.8004,1.8358,6.1043,8.3527,7.0676,7.3888c0.3236-0.3211,0.8227-1.9479,0.6447-2.5708 c-1.9279-6.7465-9.0089-15.028-12.7614-21.5495 M39.8668,62.2657c4.7581,1.8332,8.5087,0.4778,8.5087,0.4778 c-0.2625-0.3716-2.9493-1.8113-4.4778-2.4"
        />
      </g>
    </svg>
  );
};
